import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/apps/next-js/app/(auth)/login/page.tsx");
